import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CampaignsResponseDataSchema, DataResponseWithPagination, GetCampaignsSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetCampaignsSchema>
type Response = DataResponseWithPagination<z.infer<typeof CampaignsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getBackofficeCampaignsQueryKey = (companyId: string, query: Query = {}) => [
  "backoffice",
  "campaigns",
  companyId,
  query,
]

type Props = {
  companyId: string
  query?: Query
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const backofficeCampaignsQuery = ({
  companyId,
  query,
  onSuccess,
  enabled = true,
}: Props) => {
  return queryOptions({
    queryKey: getBackofficeCampaignsQueryKey(companyId, query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/campaigns/${companyId}`, {
        params: query,
      })

      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
